import { render, staticRenderFns } from "./ErrorPageLayout.vue?vue&type=template&id=a95f985c"
import script from "./ErrorPageLayout.vue?vue&type=script&lang=js"
export * from "./ErrorPageLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@neverendingsupport+vue2@2.7.22-template-compiler_@vue+compiler-sfc@_1ea54a5d08821f18e5f7625cad052d96/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports